import { Component, OnInit, OnDestroy } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CategoryService } from '../../../services/category.service';
import { ViewChild } from '@angular/core';
import { FileUpload } from 'primeng/fileupload';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ImageCroppedEvent, ImageTransform } from 'ngx-image-cropper';

@Component({
    selector: 'app-category-edit',
    templateUrl: './edit.component.html',
    styleUrls: ['./edit.component.scss'],
    providers: [ConfirmationService, MessageService]
})

export class CategoryEditComponent implements OnInit, OnDestroy {

    private destroy$ = new Subject<void>();
    categoryForm: FormGroup;
    id;
    errorMessage = '';
    submitted = false;
    statuses: any = [];
    categorystatus: any;
    parentcategory: any;
    parentcategorycode: any;
    categorylist: any = [];
    public item: any[] = [];
    uploadedFiles: any[] = [];
    public imageProfile;
    public uploadedpic;
    public showUploadedpic = false;
    @ViewChild('fileUpload') fileUpload!: FileUpload;
    imageChangedEvent: any = '';
    croppedImage: any = '';
    cropDialog: boolean = false;
    selectedFile: File | null = null;
    imageSize = 1000000;
    croppedImageMaxSize = 1000000;
    croppedImageSize = 0;
    croppedImageError: string | null = null;
    scale = 1;
    transform: ImageTransform = {};
    cropApplied = false;
    previousLogoImage: any = null;
    previousUploadedFiles: any[] = [];
  addTeamAdminDetails: boolean = false;
    constructor(private categoryService: CategoryService, private formBuilder: FormBuilder, private messageService: MessageService,
        private router: Router, private activeroute: ActivatedRoute) { }

    ngOnInit(): void {
        this.id = this.activeroute.snapshot.params.id;
        this.statuses = [
            { label: 'Active', value: true },
            { label: 'In-Active', value: false }
        ];
        this.categoryForm = this.formBuilder.group({
            name: [''],
            description: [''],
            status: ['', [Validators.required]],
            parent_category: [''],
            disable: [false],
        });
        this.getCategoryDetails(this.id);
        //this.getAllCategory();        
    }

    // getAllCategory() {
    //     this.categoryService.getAllCategory().subscribe(
    //         data => {
    //             this.categorylist = data.data.items;
    //         },
    //         err => {
    //           this.errorMessage = err.error.message;
    //         }
    //     );    
    // }

    getCategoryDetails(id) {
        this.categoryService.getCategoryDetails(id).pipe(takeUntil(this.destroy$)).subscribe(
            data => {
                this.item = data;
                if (this.item) {
                    this.categoryForm.patchValue({
                        name: this.item['name'],
                        description: this.item['description']
                    });
                    //this.categoryForm.get('status').setValue({name:  this.item['status'], code:  this.item['status']});
                    var statusobj;
                    if (this.item['status'] == true) {
                        statusobj = { label: 'Active', value: true };
                    } else {
                        statusobj = { label: 'In-Active', value: false };
                    }
                    this.categoryForm.get('status').setValue(statusobj);
                    this.categoryForm.get('parent_category').setValue({ name: this.item['parent_category'], code: this.item['parentcategorycode'] });
                    if (this.item['categoryImage'] != undefined) {
                        this.imageProfile = this.item['categoryImage'];
                        this.showUploadedpic = true;
                    } else {
                        this.showUploadedpic = false;
                    }
                }
                this.categoryForm.get('name').disable()
            },
            err => {
                this.errorMessage = err.error.message;
            }
        );
    }

    get f() {
        return this.categoryForm.controls;
    }

    onStatusSelect(event) {
        if (event) {
            this.categorystatus = event.value;
        }
    }

    onParentSelect(event) {
        if (event) {
            this.parentcategory = event.name;
            this.parentcategorycode = event.code;
        }
    }
    
    onFileSelect(event: any) {
        const file = event.files[0];
        if (!file) return;
        if (file.size > this.imageSize) {
            this.rejectOversizedImage();
            return;
        }
        this.croppedImageError = null;
        this.croppedImageSize = 0;
        this.selectedFile = file;
        const fileEvent: any = {
            target: {
                files: [file]
            }
        };
        this.imageChangedEvent = fileEvent;
        this.cropDialog = true;
    }

    // imageCropped(event: ImageCroppedEvent) {
    //     this.croppedImage = event.base64;
    //     this.croppedImageSize = this.getBase64SizeBytes(this.croppedImage);
    //     this.croppedImageError = this.croppedImageSize > this.croppedImageMaxSize
    //         ? 'Cropped image size must be less than 1 MB.'
    //         : null;
    // }

    getBase64SizeBytes(base64: string): number {
        if (!base64) return 0;
        return Math.round(
            (base64.length * (3 / 4)) -
            (base64.split(',')[0].length + 1)
        );
    }

    applyCrop() {
        if (this.croppedImageError) return;
        const file = this.base64ToFile(
            this.croppedImage,
            this.selectedFile?.name || 'image.png'
        );
        if (file.size > this.croppedImageMaxSize) {
            this.croppedImageError = 'Cropped image size must be less than 1 MB.';
            return;
        }
        this.fileUpload.clear();
        const event = {
            files: [file]
        };
        this.picUploader(event);
        this.fileUpload.files = [file];
        this.cropDialog = false;
    }

    onCropCancel() {
        this.cropDialog = false;
        this.imageChangedEvent = null;
        this.croppedImage = null;
        this.croppedImageError = null;
        this.croppedImageSize = 0;
        this.selectedFile = null;
        if (this.fileUpload) {
            this.fileUpload.clear();
        }
        this.uploadedFiles = [];
        this.uploadedpic = null;
    }

    // rejectOversizedImage() {
    //     this.messageService.add({ key: 'toastmsg', severity: 'error', summary: 'File Too Large', detail: 'Please upload an image smaller than 1 MB', life: 6000 });
    //     this.onCropCancel();
    // }

    base64ToFile(data: string, filename: string): File {
        const arr = data.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, { type: mime });
    }

    picUploader(event) {
        for (let file of event.files) {
            this.uploadedFiles.push(file);
            var reader = new FileReader();
            reader.readAsDataURL(this.uploadedFiles[0]);
            reader.onload = () => { // called once readAsDataURL is completed
                this.uploadedpic = reader.result;
            }
        }
    }
 
    removeFile(event) {
        this.uploadedFiles = [];
        this.uploadedpic = null;
    }

    onSubmit() {
        this.submitted = true;
        // stop here if form is invalid
        if (this.categoryForm.invalid) {
            return;
        }
        var categoryData = this.categoryForm.value;
        categoryData['status'] = this.categorystatus;
        categoryData['parent'] = this.parentcategorycode;
        categoryData['categoryImage'] = this.uploadedpic;
        delete categoryData.parent_category;

        categoryData = JSON.stringify(categoryData, null, 4);
        // alert('SUCCESS!! :-)\n\n' + JSON.stringify(this.categoryForm.value, null, 4));
        // return;
        this.categoryService.updateCategory(this.id, categoryData).pipe(takeUntil(this.destroy$)).subscribe(
            data => {
                this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Category Updated', life: 6000 });
                setTimeout(() => {
                    this.router.navigate(['/manage/category/category']);
                }, 2000);

            },
            ((err) => {
                this.messageService.add({ key: 'toastmsg', severity: 'error', summary: err.error.message, detail: 'Update Category failed', life: 6000 });
            })
        );
    }

    backLink() {
        this.router.navigate(['/manage/category/category']);
    }

    get cropDialogTitle(): string {
        return 'Crop & Adjust Category';
    }

    get cropDialogSubtitle(): string {
        return 'Position and scale image to fit mandatory 300 x 300 dimensions';
    }

    get cropPreviewLabel(): string {
        return '300 x 300 px';
    }

    zoomIn() {
        this.scale += 0.1;
        this.transform = {
            ...this.transform,
            scale: this.scale
        };
    }

    zoomOut() {
        if (this.scale > 0.2) {
            this.scale -= 0.1;
            this.transform = {
                ...this.transform,
                scale: this.scale
            };
        }
    }

    resetZoom() {
        this.scale = 1;
        this.transform = {
            ...this.transform,
            scale: 1
        };
    }

    imageCropped(event: ImageCroppedEvent) {
        this.croppedImage = event.base64;
        this.croppedImageSize = this.getBase64SizeBytes(this.croppedImage);
        this.croppedImageError = this.croppedImageSize > this.croppedImageMaxSize
            ? 'Cropped image size must be less than 1 MB.'
            : null;
    }

    onDialogHide() {
        if (!this.cropApplied) {
            this.restorePreviousLogo();
        }
        this.resetCropState();
    }

    private restorePreviousLogo() {
        this.imageProfile = this.previousLogoImage;
        this.uploadedFiles = [...this.previousUploadedFiles];

        if (this.fileUpload) {
            this.fileUpload.clear();
            this.fileUpload.files = [...this.previousUploadedFiles];
        }
    }

    private resetCropState() {
        this.imageChangedEvent = null;
        this.croppedImage = null;
        this.croppedImageError = null;
        this.croppedImageSize = 0;
        this.selectedFile = null;
        this.previousLogoImage = null;
        this.previousUploadedFiles = [];
        this.cropApplied = false;
        this.resetZoom();
    }

    rejectOversizedImage() {
        this.messageService.add({ key: 'toastmsg', severity: 'error', summary: 'File Too Large', detail: 'Please upload an image smaller than 1 MB', life: 6000 });
        this.restorePreviousLogo();
        this.resetCropState();
    }

    ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
